import { useMemo } from 'react';
import type { EditOrderViewModel } from '../hooks/use-edit-order-view';
import { AddProductModal } from './add-product-modal';
import { DealsFamilyView } from './deals-family-view';
import { EditOrderTable } from './edit-order-table';
import { EditOrderToolbar } from './edit-order-toolbar';
import { BuyupSummaryHeader } from './order-summary-header';

export function BuyupView({ view }: { view: EditOrderViewModel }) {
  const { addModalFamily } = view;

  // See OrderView: the header reduces over every item on each re-render, so the
  // element is memoized on exactly the data it reads.
  const headerContent = useMemo(
    () => (
      <BuyupSummaryHeader
        items={view.filteredOrderItems}
        columns={view.orderedVisibleColumns}
        columnSizing={view.columnSizing}
      />
    ),
    [view.filteredOrderItems, view.orderedVisibleColumns, view.columnSizing]
  );

  return (
    <>
      <EditOrderToolbar view={view} />
      {view.isVolumeDeals ? (
        <>
          <DealsFamilyView
            orderItems={view.orderItems}
            searchQuery={view.query}
            setOrderItem={view.setOrderItem}
            allocateDeal={view.allocateDeal}
            onAddProductClicked={view.setAddModalFamily}
            onRemoveMember={(item) => view.removeProductFromFamily(item.product)}
            scrollOffsetsStore={view.scrollOffsetsStore}
          />
          {addModalFamily && (
            <AddProductModal
              family={addModalFamily}
              onClose={() => view.setAddModalFamily(null)}
              onAdd={(product) => view.joinProductToFamily(product, addModalFamily.id)}
            />
          )}
        </>
      ) : (
        <EditOrderTable view={view} headerContent={headerContent} />
      )}
    </>
  );
}
